var drawer = function () {

    var settings = {
      speedOpen: 50,
      speedClose: 350,
      activeClass: 'is-active',
      visibleClass: 'is-visible',
      selectorTarget: '[data-drawer-target]',
      selectorTrigger: '[data-drawer-trigger]',
      selectorClose: '[data-drawer-close]',

    };


    // Listen for open drawer
    $(document).on('click', '#cart-icon-bubble', function() {
        $('#cart-drawer').addClass(settings.activeClass);
        setTimeout(function () {
            $('#cart-drawer').addClass(settings.visibleClass);
        }, settings.speedOpen);
    });

    // Listen for close drawer
    $(document).on('click', '[data-drawer-close],#MainContent', function() {
        $('#cart-drawer').removeClass(settings.visibleClass);
        setTimeout(function () {
            $('#cart-drawer').removeClass(settings.activeClass);
        }, settings.speedClose);
    });

};

var checkoutClicked = function () {

    // Listen for open drawer
    $(document).on('click', '#checkout', function(e) {
    
      $('#checkout').find('.spinner-border').removeClass('hidden');
      $('#checkout').find('.checkout__text').addClass('hidden');

// 		var paramCart = '&cart_token=' + (document.cookie.match('(^|; )cart=([^;]*)')||0)[2];
//         $.ajax({
//             type: 'GET',
//             url: '/cart.js',
//             dataType: 'text',
//             success: function(data) {
//                 if (data.indexOf("shipping_interval_frequency") > -1) {
//                     var paramDomain = 'myshopify_domain=sun-coast-sciences.myshopify.com';
//                     try {
//                         var paramLinker = "&" + ga.getAll()[0].get('linkerParam');
//                     } catch (err) {
//                         var paramLinker = '';
//                     }
//                     // var paramCustomer = '{% if customer %}&email={{ customer.email }}{% endif %}';
//                     window.location = "https://checkout.rechargeapps.com/r/checkout?" + paramDomain +  paramCart + paramLinker
//                 } else {
//                     window.location = '/checkout';
//                 }
//             }
//         });
    });


};

var removeItemFromCart = function () {

    // Listen for open drawer
    $(document).on('click', '.cart-remove', function(e) {
      e.preventDefault();
      var url_string = $(this).find("a").attr('href');
      
       $.ajax({
            type: 'POST',
            url: url_string,
            dataType: 'json',
            success: function(){
               window.location.href = cartUrl;
            }
        });

    });
};

$(function() {
    drawer();
    checkoutClicked();
    removeItemFromCart();
});